import i18n from 'i18next';

export const translateText = ({
  text,
  globalLanguage,
  loadingText,
  setLoadingText,
}) => {
  if (typeof text !== 'string') return text;
  if (globalLanguage === 'ko' || !i18n.exists(text)) {
    return text;
  } else {
    return i18n.t(text);
  }
};
